class MegaMenu extends HTMLElement {
    constructor() {
        super();
        this.menuItemsFirst = null;
        this.menuItemsFirstTab = null;
        this.menuItemsSecond = null;
        this.menuItemsImagesContainer = null;
    }

    connectedCallback() {
        this.menuItemsFirst = this.querySelectorAll('.mega-menu-list__first-level-item');
        this.menuItemsFirstTab = this.querySelectorAll('.mega-menu-list__second-level-item');
        this.menuItemsSecond = this.querySelectorAll('.mega-menu-list__second-level-list-link');
        this.menuItemsImagesContainer = this.querySelectorAll('.mega-menu-list__images-container');

        // ✅ Set default active on first child item (with submenu)
        const defaultFirstChild = this.querySelector('.mega-menu-list__first-level-item--child');
        if (defaultFirstChild) {
            this.setActiveTab(defaultFirstChild, "first");
        }

        // ✅ First-level item hover
        this.menuItemsFirst.forEach(item => {
            item.addEventListener('mouseenter', () => {
                const isChild = item.classList.contains('mega-menu-list__first-level-item--child');
                
                if (isChild) {
                    this.activateTab(item.id, "first");
                } else {
                    // Clear all active classes if item has no child
                    this.clearAllActiveStates();
                    this.menuItemsFirst.forEach(i => i.classList.remove('active'));
                    item.classList.add('active'); // Optional: show visual active state
                }
            });
        });

        // ✅ Second-level link hover (to show image)
        this.menuItemsSecond.forEach(item => {
            item.addEventListener('mouseenter', () => {
                this.activateTab(item.id, "second");
            });
        });
    }

    // 🔄 Set active tab
    setActiveTab(item, level = "first") {
        let menuItems, tabs;

        if (level === "first") {
            menuItems = this.menuItemsFirst;
            tabs = this.menuItemsFirstTab;

            // Remove all active classes
            this.clearAllActiveStates();

            // Activate current first-level item
            item.classList.add('active');

            // Show corresponding second-level menu
            const activeTab = this.querySelector(`.mega-menu-list__second-level-item[data-tab="${item.id}"]`);
            if (activeTab) {
                activeTab.classList.add('active');
            }

        } else if (level === "second") {
            menuItems = this.menuItemsSecond;
            tabs = this.menuItemsImagesContainer;

            // Clear second-level image area only
            this.menuItemsSecond.forEach(i => i.classList.remove('active'));
            this.menuItemsImagesContainer.forEach(img => img.classList.remove('active'));

            // Add active class to hovered second-level link
            item.classList.add('active');

            // Show corresponding image container
            const activeImage = this.querySelector(`.mega-menu-list__images-container[data-tab="${item.id}"]`);
            if (activeImage) {
                activeImage.classList.add('active');
            }
        }
    }

    // 🔁 Helper to clear all active states
    clearAllActiveStates() {
        this.menuItemsFirst.forEach(i => i.classList.remove('active'));
        this.menuItemsFirstTab.forEach(t => t.classList.remove('active'));
        this.menuItemsSecond.forEach(i => i.classList.remove('active'));
        this.menuItemsImagesContainer.forEach(img => img.classList.remove('active'));
    }

    // 🔄 Get item and delegate to setActiveTab
    activateTab(id, level) {
        const selector = level === "first"
            ? `.mega-menu-list__first-level-item[id="${id}"]`
            : `.mega-menu-list__second-level-list-link[id="${id}"]`;

        const activeItem = this.querySelector(selector);
        if (activeItem) {
            this.setActiveTab(activeItem, level);
        }
    }
}

customElements.define('mega-menu', MegaMenu);
